import { render, staticRenderFns } from "./tsxx.vue?vue&type=template&id=bdca9ac2&scoped=true"
import script from "./tsxx.vue?vue&type=script&lang=js"
export * from "./tsxx.vue?vue&type=script&lang=js"
import style0 from "./tsxx.vue?vue&type=style&index=0&id=bdca9ac2&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdca9ac2",
  null
  
)

export default component.exports